
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $b2797c645bb5a32a$exports = {};
var $9e59d8498d741981$exports = {};

$parcel$export($9e59d8498d741981$exports, "TurnstileWidget", () => $9e59d8498d741981$export$2d5eb10967009188);
var $a3e2818a88ab744e$exports = {};

$parcel$export($a3e2818a88ab744e$exports, "TurnstileWidgetFrame", () => $a3e2818a88ab744e$export$3be674d33890c395);
class $a3e2818a88ab744e$export$3be674d33890c395 extends HTMLElement {
    static _currentIdentifier;
    static get currentIdentifier() {
        return $a3e2818a88ab744e$export$3be674d33890c395._currentIdentifier;
    }
    static set currentIdentifier(identifier) {
        $a3e2818a88ab744e$export$3be674d33890c395._currentIdentifier = identifier;
    }
    get siteKey() {
        return this.getAttribute("site-key");
    }
    set siteKey(value) {
        if (this.getAttribute("site-key") !== value && value) this.setAttribute("site-key", value);
    }
    get theme() {
        return this.getAttribute("theme");
    }
    set theme(value) {
        if (this.getAttribute("theme") !== value && value) this.setAttribute("theme", value);
    }
    get size() {
        return this.getAttribute("size");
    }
    set size(value) {
        if (this.getAttribute("size") !== value && value) this.setAttribute("size", value);
    }
    get retry() {
        return this.getAttribute("retry");
    }
    set retry(value) {
        if (this.getAttribute("retry") !== value && value) this.setAttribute("retry", value);
    }
    get refreshExpired() {
        return this.getAttribute("refresh-expired");
    }
    set refreshExpired(value) {
        if (this.getAttribute("refresh-expired") !== value && value) this.setAttribute("refresh-expired", value);
    }
    /**
     * Initializes the component.
     *
     * @hideconstructor
     */ constructor(){
        super();
    }
    /**
     * Setup the component once added to the DOM.
     */ connectedCallback() {
        const div = document.createElement("div");
        div.style.height = "100%";
        this.appendChild(div);
        const widgetLoad = (identifier)=>{
            div.id = identifier;
            turnstile.ready(()=>{
                turnstile.render(div, {
                    sitekey: this.siteKey,
                    callback: (token)=>{
                        $a3e2818a88ab744e$export$3be674d33890c395.messageApplication($a3e2818a88ab744e$export$3be674d33890c395.currentIdentifier, "success", token);
                    },
                    "error-callback": (errorCode)=>{
                        $a3e2818a88ab744e$export$3be674d33890c395.messageApplication($a3e2818a88ab744e$export$3be674d33890c395.currentIdentifier, "error", errorCode);
                    },
                    "expired-callback": ()=>{
                        $a3e2818a88ab744e$export$3be674d33890c395.messageApplication($a3e2818a88ab744e$export$3be674d33890c395.currentIdentifier, "expired");
                    },
                    "unsupported-callback": ()=>{
                        $a3e2818a88ab744e$export$3be674d33890c395.messageApplication($a3e2818a88ab744e$export$3be674d33890c395.currentIdentifier, "unsupported");
                    },
                    theme: this.theme ? this.theme : "auto",
                    size: this.size ? this.size : "normal",
                    retry: this.retry ? this.retry : "auto",
                    "refresh-expired": this.refreshExpired ? this.refreshExpired : "auto"
                });
            });
        };
        $a3e2818a88ab744e$export$3be674d33890c395.initialize(widgetLoad);
    }
    /**
     * Send a bridged message to the hosting application frame as a widget.
     *
     * @param identifier Identifier to represent widget.
     * @param eventName Name of event to send to application.
     * @param detail Custom detail to attach as event detail.
     * @param callback (Optional) Callback function to invoke on widget response.
     * @param timeout (Optional) Duration to wait for callback.
     * @param timeoutCallback (Optional) Callback function to invoke if response timeout is exceeded
     * @param callbackIdentifierPrefix (Optional) Prefix to apply on generated widget callback id
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static messageApplication(identifier, eventName, detail, callback, timeout, timeoutCallback, callbackIdentifierPrefix = "widget-callback") {
        if (window === window.parent) throw new Error("No parent application to message!");
        // Build up bridge event with provided detail
        const bridgeEvent = {
            bridgeEvent: eventName,
            detail: detail,
            fromApplication: false,
            identifier: identifier,
            callbackId: undefined
        };
        if (callback) {
            let resolved = null;
            // If callback function is specified, setup temporary event for callback response
            const callbackId = `${callbackIdentifierPrefix}|${$a3e2818a88ab744e$export$3be674d33890c395.uuidv4()}`;
            bridgeEvent.callbackId = callbackId;
            const callbackHandler = (e)=>{
                if (resolved === null) {
                    resolved = true;
                    $a3e2818a88ab744e$export$3be674d33890c395.removeEventListener(callbackListener);
                    // eslint-disable-next-line callback-return, @typescript-eslint/no-unsafe-argument
                    callback(e.content);
                }
            };
            if (timeout) setTimeout(()=>{
                if (resolved === null) {
                    resolved = false;
                    $a3e2818a88ab744e$export$3be674d33890c395.removeEventListener(callbackListener);
                    if (timeoutCallback) timeoutCallback();
                }
            }, timeout);
            const callbackListener = $a3e2818a88ab744e$export$3be674d33890c395.addEventListener(callbackId, callbackHandler);
        }
        window.parent.postMessage(JSON.parse(JSON.stringify(bridgeEvent)), `*`);
    }
    /**
     * Generate a unique identifier string
     */ static uuidv4() {
        if (crypto && crypto.randomUUID) try {
            const uuid = crypto.randomUUID();
            if (uuid) return uuid;
        } catch (error) {
            console.warn(error);
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/restrict-plus-operands, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c)=>(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
    }
    /**
     * Asynchronously sends a bridged message to the hosting application frame as a widget, then awaits and returns its response.
     * @param identifier Identifier to represent widget.
     * @param eventName The event this message correlates to.
     * @param detail Custom detail to attach as event detail.
     * @param timeout (Optional) Duration to wait for before rejecting the promise. If not specified, will wait indefinitely.
     * @param callbackIdentifierPrefix (Optional) Prefix to apply on generated widget callback id
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static messageApplicationAsync(identifier, eventName, detail, timeout = 3000, callbackIdentifierPrefix = "widget-callback") {
        return new Promise((resolve, reject)=>{
            try {
                $a3e2818a88ab744e$export$3be674d33890c395.messageApplication(identifier, eventName, detail, resolve, timeout, ()=>reject(new Error(`No response received for '${eventName}' in the given timeout: ${timeout}ms`)), callbackIdentifierPrefix);
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
     * Set up a callback for the `frame-load` event from the widget component in a hosting application.
     * Can be used by a widget application to retrieve its identifier from the widget component.
     * @param frameLoaded The callback to invoke when the `frame-load` event occurs.
     */ static initialize(frameLoaded) {
        // Listen for messages on the widget window. Used for communication with the parent application
        const listener = $a3e2818a88ab744e$export$3be674d33890c395.addEventListener(`frame-load`, (event)=>{
            $a3e2818a88ab744e$export$3be674d33890c395.currentIdentifier = event.content;
            $a3e2818a88ab744e$export$3be674d33890c395.removeEventListener(listener);
            frameLoaded(event.content);
        });
    }
    /**
     * Set up a callback for the specified event from the widget component in a hosting application.
     * @param eventName The event name to listen for when receiving bridged messages.
     * @param listener The callback to invoke when the specified event occurs.
     * @returns Event listener instance that can be used to remove the listener via `Widget.removeEventListener`
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static addEventListener(eventName, listener) {
        // Listen for messages on the widget window. Used for communication with the parent application
        const messageListener = (event)=>{
            // Check if received message is a parent application message
            if (typeof event.data === `object` && event.data.bridgeEvent && event.data.fromApplication === true && event.data.bridgeEvent === eventName) {
                $a3e2818a88ab744e$export$3be674d33890c395.currentIdentifier = event.data.identifier;
                listener({
                    content: event.data.detail,
                    callback: event.data.callbackId ? (detail)=>{
                        $a3e2818a88ab744e$export$3be674d33890c395.messageApplication(event.data.identifier, event.data.callbackId, detail);
                    } : undefined
                });
            }
        };
        window.addEventListener(`message`, messageListener);
        return messageListener;
    }
    /**
     * Remove the listener from the widget component in a hosting application.
     * @param messageListener The listener instance created by `Widget.addEventListener` to remove
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static removeEventListener(messageListener) {
        window.removeEventListener(`message`, messageListener);
    }
}
customElements.define("turnstile-widget-frame", $a3e2818a88ab744e$export$3be674d33890c395);


var $399f742e3f077488$exports = {};

$parcel$export($399f742e3f077488$exports, "VERSION", () => $399f742e3f077488$export$a4ad2735b021c132);
const $399f742e3f077488$export$a4ad2735b021c132 = "0.3.0";


const $9e59d8498d741981$var$SCRIPT_URL = "https://challenges.cloudflare.com/turnstile/v0/api.js";
class $9e59d8498d741981$export$2d5eb10967009188 extends HTMLElement {
    /**
     * Internal instance of `HTMLIFrameElement`.
     */ iframe;
    /**
     * Unique identifier for widget with which to track widget specific events.
     */ identifier = (0, $a3e2818a88ab744e$export$3be674d33890c395).uuidv4();
    /**
     * Every widget has a sitekey. This sitekey is associated with the corresponding widget configuration and is created upon the widget creation.
     * @see https://developers.cloudflare.com/turnstile/get-started/client-side-rendering/#configurations
     * @attr site-key
     */ get siteKey() {
        return this.getAttribute("site-key");
    }
    set siteKey(value) {
        if (this.getAttribute("site-key") !== value && value) this.setAttribute("site-key", value);
    }
    /**
     * The widget theme. Can take the following values: light, dark, auto.
     * The default is auto, which respects the user preference. This can be forced to light or dark by setting the theme accordingly.
     * @default 'auto'
     * @attr
     */ get theme() {
        return this.getAttribute("theme");
    }
    set theme(value) {
        if (this.getAttribute("theme") !== value && value) this.setAttribute("theme", value);
    }
    /**
     * The widget size. Can take the following values: normal, compact.
     * Normal is 300px by 65px, and compact is 130px by 120px.
     * @see https://developers.cloudflare.com/turnstile/get-started/client-side-rendering/#widget-size
     * @default 'normal'
     * @attr
     */ get size() {
        return this.getAttribute("size");
    }
    set size(value) {
        if (this.getAttribute("size") !== value && value) this.setAttribute("size", value);
    }
    /**
     * Controls whether the widget should automatically retry to obtain a token if it did not succeed.
     * The default is auto, which will retry automatically. This can be set to never to disable retry upon failure.
     * @see https://developers.cloudflare.com/turnstile/get-started/client-side-rendering/#configurations
     * @default 'auto'
     * @attr
     */ get retry() {
        return this.getAttribute("retry");
    }
    set retry(value) {
        if (this.getAttribute("retry") !== value && value) this.setAttribute("retry", value);
    }
    /**
     * Automatically refreshes the token when it expires. Can take auto, manual or never, defaults to auto.
     * @see https://developers.cloudflare.com/turnstile/get-started/client-side-rendering/#configurations
     * @default 'auto'
     * @attr refresh-expired
     */ get refreshExpired() {
        return this.getAttribute("refresh-expired");
    }
    set refreshExpired(value) {
        if (this.getAttribute("refresh-expired") !== value && value) this.setAttribute("refresh-expired", value);
    }
    get widgetFrameURL() {
        const explicitFrameURL = window["turnstile-widget-frame-module-url"];
        if (explicitFrameURL) return explicitFrameURL;
        return `https://www.unpkg.com/cloudflare-turnstile-widget@${0, $399f742e3f077488$export$a4ad2735b021c132}/dist/TurnstileWidgetFrame.js`;
    }
    componentMessageListener = ((event)=>{
        const eventData = event.data;
        // Check if received message is a widget message from this wrapper's hosted widget
        if (typeof event.data === `object` && eventData.bridgeEvent && eventData.identifier === this.identifier && eventData.fromApplication !== true) this.frameMessageReceived(event);
    }).bind(this);
    /**
     * Initializes the component.
     *
     * @hideconstructor
     */ constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    /**
     * Setup the component once added to the DOM.
     */ connectedCallback() {
        // Listen for messages on the application window. Used for communication with the child widget.
        window.addEventListener("message", this.componentMessageListener);
        this.iframe = document.createElement("iframe");
        const style = document.createElement("style");
        const height = this.size === "compact" ? "120px;" : "65px;";
        const width = this.size === "compact" ? "130px;" : "300px;";
        style.textContent = `
            .body {
                border: none;
                height: ${height}
                width: ${width}
                margin: 0;
                overflow: hidden;
            }

            :host {
                position: relative;
            }
        `;
        this.shadowRoot?.appendChild(style);
        this.iframe.classList.add("body");
        this.iframe.srcdoc = `
            <head>
                <script src="${$9e59d8498d741981$var$SCRIPT_URL}?render=explicit"></script>
                <script type="module" src="${this.widgetFrameURL}"></script>
            </head>
            <body style="border: none; height: ${height} width: ${width} margin: 0; overflow: hidden;">
                <turnstile-widget-frame
                    site-key="${this.siteKey}"
                    theme="${this.theme ? this.theme : "auto"}"
                    size="${this.size ? this.size : "normal"}"
                    retry="${this.retry ? this.retry : "auto"}"
                    refresh-expired="${this.refreshExpired ? this.refreshExpired : "auto"}">
                </turnstile-widget-frame>
            </body>
        `;
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        this.iframe.addEventListener("load", ()=>this.frameLoaded());
        this.shadowRoot?.appendChild(this.iframe);
    }
    /**
     * Clean up the component once removed from the DOM.
     */ disconnectedCallback() {
        // Cleanup listeners
        window.removeEventListener(`message`, this.componentMessageListener);
        const children = Array.from([
            ...this.shadowRoot?.children ?? []
        ]);
        children.forEach((c)=>c.remove());
    }
    /**
     * Dispatch a custom event to say the iframe is loaded, the TurnstileWidgetFrame component listens to this event.
     */ // eslint-disable-next-line @typescript-eslint/require-await
    async frameLoaded() {
        // Raise frame load event
        this.dispatchEvent(new CustomEvent("frame-load", {
            bubbles: true,
            composed: true,
            cancelable: false,
            detail: this.identifier
        }));
        this.messageFrame("frame-load", this.identifier);
    }
    frameMessageReceived(event) {
        // Create and dispatch custom event based on bridge event info
        const evt = {
            detail: {
                content: event.data.detail,
                // Check whether a temporary callback event has been provided, and if so, setup function to return the callback response.
                callback: event.data.callbackId ? (detail)=>{
                    this.messageFrame(event.data.callbackId, detail);
                } : undefined
            },
            bubbles: true,
            composed: true,
            cancelable: true
        };
        this.dispatchEvent(new CustomEvent("bridge-message", {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: event.data
        }));
        this.dispatchEvent(new CustomEvent(event.data.bridgeEvent, evt));
    }
    /**
     * Send a bridged message to the hosted widget frame.
     * @param eventName The event this message correlates to.
     * @param detail Custom detail to attach as event detail.
     * @param callback (Optional) Callback function to invoke on widget response.
     * @param timeout (Optional) Duration to wait for callback.
     * @param timeoutCallback (Optional) Callback function to invoke if response timeout is exceeded
     * @param callbackIdentifierPrefix (Optional) Prefix to apply on generated widget callback id
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    messageFrame(eventName, detail, callback, timeout, timeoutCallback, callbackIdentifierPrefix = "widget-callback") {
        const frameWindow = this.iframe.contentWindow;
        let callbackId = undefined;
        if (callback) {
            let resolved = null;
            // If callback function is specified, setup temporary event for callback response
            callbackId = `${callbackIdentifierPrefix}|${(0, $a3e2818a88ab744e$export$3be674d33890c395).uuidv4()}`;
            let callbackHandler = (e)=>{
                if (resolved === null) {
                    resolved = true;
                    window.removeEventListener(callbackId, callbackHandler);
                    // eslint-disable-next-line callback-return, @typescript-eslint/no-unsafe-argument
                    callback(e.detail);
                }
            };
            callbackHandler = callbackHandler.bind(this);
            if (timeout) setTimeout(()=>{
                if (resolved === null) {
                    resolved = false;
                    window.removeEventListener(callbackId, callbackHandler);
                    if (timeoutCallback) timeoutCallback();
                }
            }, timeout);
            window.addEventListener(callbackId, callbackHandler);
        }
        const bridgeEvent = {
            bridgeEvent: eventName,
            detail: detail,
            identifier: this.identifier,
            fromApplication: true,
            callbackId: callbackId
        };
        frameWindow?.postMessage(bridgeEvent, `*`);
    }
    /**
     * Asynchronously sends a bridged message to the hosted widget frame, then awaits and returns its response.
     * @param eventName The event this message correlates to.
     * @param detail Custom detail to attach as event detail.
     * @param timeout (Optional) Duration to wait for before rejecting the promise. If not specified, will wait indefinitely
     * @param callbackIdentifierPrefix (Optional) Prefix to apply on generated widget callback id.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    messageFrameAsync(eventName, detail, timeout, callbackIdentifierPrefix = "widget-callback") {
        return new Promise((resolve, reject)=>{
            try {
                this.messageFrame(eventName, detail, resolve, timeout, timeout ? ()=>reject(new Error(`No response received for '${eventName}' in the given timeout: ${timeout}ms`)) : undefined, callbackIdentifierPrefix);
            } catch (error) {
                reject(error);
            }
        });
    }
}
customElements.define("turnstile-widget", $9e59d8498d741981$export$2d5eb10967009188);




$parcel$exportWildcard($b2797c645bb5a32a$exports, $9e59d8498d741981$exports);
$parcel$exportWildcard($b2797c645bb5a32a$exports, $a3e2818a88ab744e$exports);
$parcel$exportWildcard($b2797c645bb5a32a$exports, $399f742e3f077488$exports);


//# sourceMappingURL=career-services.d453753d.js.map
